module.exports = __webpack_public_path__ + "img/show_cooking.ec72034d.png";